<ion-item>
  <ion-label [translate]="item.get('name')" (click)="toggle($event)"></ion-label>
  <ion-toggle [checked]="item.getVisible()" (ionChange)="onChange($event)" color="success"></ion-toggle>
</ion-item>
